import React from 'react';
import styled from 'styled-components';
import { Button, Card, List, Skeleton, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import { useTheme } from '../../../../../hooks/useTheme';
import { getSrc } from '../../../../../utils/common/getSrc';
import postPlaceholder from '../../../../../static/images/post_placeholder.png';

interface IPostList {
    readonly title: string;
    readonly isFetching: boolean;
    readonly isError: boolean;
    readonly filters: {
        limit: number;
        offset: number;
    };
    readonly onFiltersUpdate: (update, type) => void;
    readonly data: {
        posts: IPost[];
        total: number;
    };
}

interface IPost {
    readonly background_image: string;
    readonly title: string;
    readonly description: string;
    readonly uuid: string;
}
export const PostList: React.FC<IPostList> = props => {
    const { title, isFetching, isError, data, filters, onFiltersUpdate } =
        props;
    const navigate = useNavigate();
    const token = useTheme();

    const pagination = {
        current: filters.offset / filters.limit + 1,
        showLessItems: true,
        showTitle: true,
        defaultPageSize: 3,
        total: data.total,
        showTotal: () => `Постов: ${data.total}`,
        onChange: (page, pageSize) => {
            onFiltersUpdate(
                {
                    limit: pageSize,
                    offset: (page - 1) * pageSize,
                },
                'post'
            );
        },
    };

    return (
        <StyledWrapper>
            <StyledPageTitle level={2}>{title}</StyledPageTitle>
            {isFetching || isError ? (
                <Skeleton />
            ) : (
                <List
                    grid={{
                        gutter: 16,
                        xs: 1,
                        sm: 2,
                        md: 3,
                        lg: 3,
                        xl: 3,
                        xxl: 3,
                    }}
                    loading={isFetching}
                    dataSource={data.posts}
                    renderItem={(post, index) => (
                        <List.Item>
                            <Card
                                type='inner'
                                style={token.Card}
                                key={index}
                                cover={
                                    <StyledCover
                                        src={
                                            !post.background_image
                                                ? postPlaceholder
                                                : getSrc(
                                                      `/storage/${post.background_image}`
                                                  )
                                        }
                                        alt='post image'
                                    />
                                }
                            >
                                <StyledTitle level={5}>
                                    {post.title}
                                </StyledTitle>
                                <StyledDescription
                                    ellipsis={{
                                        rows: 2,
                                    }}
                                >
                                    <StyledSpan
                                        dangerouslySetInnerHTML={{
                                            __html: post.description,
                                        }}
                                    ></StyledSpan>
                                </StyledDescription>
                                <StyledActions>
                                    <StyledButton
                                        onClick={() =>
                                            navigate(`post/${post.uuid}`)
                                        }
                                        // onClick={() => handleReadPost(post)}
                                    >
                                        Читать
                                    </StyledButton>
                                </StyledActions>
                            </Card>
                        </List.Item>
                    )}
                    pagination={pagination}
                />
            )}
        </StyledWrapper>
    );
};

const StyledWrapper = styled.div`
    margin: 1.5rem 0 3rem 0;
`;

const StyledPageTitle = styled(Typography.Title)`
    margin: 0;
`;

const StyledButton = styled(Button)`
    width: 100%;
`;

const StyledTitle = styled(Typography.Title)`
    margin: 1rem 0;
`;

const StyledDescription = styled(Typography.Paragraph)`
    min-height: 44px;
    margin: 1rem 0;
`;

const StyledActions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 20px;
`;

const StyledCover = styled.img`
    object-fit: cover;
    width: 150px;
    height: 250px;
`;

const StyledSpan = styled.span`
    p {
        margin-bottom: 0;
        margin-top: 0;
    }
`;
